<template>
  <div class="passwordetail">
    <div class="passwordetail_title">
      <p>我的订单</p>
    </div>
    <div>

      <div style="margin-left: 20px">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="全部" name="first"></el-tab-pane>
          <el-tab-pane label="已付费" name="second"></el-tab-pane>
          <el-tab-pane label="未付费" name="third"></el-tab-pane>
        </el-tabs>

        <el-table
                :data="tableData"
                style="width: 100%">
          <el-table-column
                  prop="created_at"
                  label="订单日期"
                  width="180">
          </el-table-column>
          <el-table-column
                  prop="cus_id"
                  label="姓名"
                  width="180">
          </el-table-column>
          <el-table-column
                  prop="order_amount"
                  label="金额"
                  width="180">
          </el-table-column>

          <el-table-column
                  prop="title"
                  label="备注">
          </el-table-column>
        </el-table>

      </div>


    </div>
  </div>
</template>

<script>
import {getMyOrders} from "../../api/moudles/user";

export default {
  name: "myorder",

  data() {
    return {
      activeName: 'first',

      status:2 ,
      tableData: [
            /*  {
        date: '2016-05-02',
        name: '王小虎',
        price: '1',
        address: '上海市普陀区金沙江路 1518 弄'
      }, {
        date: '2016-05-04',
        name: '王小虎',
        price: '1',
        address: '上海市普陀区金沙江路 1517 弄'
      }, {
        date: '2016-05-01',
        name: '王小虎',
        price: '1',
        address: '上海市普陀区金沙江路 1519 弄'
      }, {
        date: '2016-05-03',
        name: '王小虎',
        price: '1',
        address: '上海市普陀区金沙江路 1516 弄'
      }*/

      ]
    }
  },
  created() {
    document.title = '我的订单'
    this.fetchData()
  },
  methods: {
    handleClick(tab) {
      console.log(tab);

      if(tab.index == 0){
        this.status = 2
      }else if(tab.index == 1){

        this.status = 20
      }else if(tab.index == 2){

        this.status = 10
      }

      this.fetchData()
    },
    fetchData(){

      let token = localStorage.getItem('userToken')
      let that = this
      getMyOrders({
        data: {
          token:token,
          status :this.status
        },
        success: (res) => {

          console.log(res)

          this.tableData = res.data

          if(res.code == -1){

            that.$message.error("登录状态失效，请重新登录");

            setTimeout(function () {

              //localStorage.clear()
              localStorage.removeItem('userToken')
              localStorage.removeItem('userName')
              localStorage.removeItem('userAvatar')
              that.$bus.$emit('brotherEvent', 'login')
              that.$router.push('/login')

            },1000)
          }

        }
      })
    }


  }
}
</script>

<style scoped>

.passwordetail {
  min-height: 650px;
  background-color: #fff;
}

.passwordetail_title {
  height: 60px;
  font-weight: 500;
  font-size: 22px;
  line-height: 60px;
  padding-left: 20px;
  border-bottom: 1px solid #f2f2f2;
}

.passwordetail_body{
  min-height: 600px;
  display: flex;;
  justify-content: center;
  align-content: center;
}
/**滚动条的宽度*/
::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

/*滚动条的滑块*/
::-webkit-scrollbar-thumb {
  background-color: rgb(185, 221, 255);
  border-radius: 5px;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(24,144,255,.8);
}

</style>